<template>
  <div style="padding-bottom: 50px">
    <div class="header" style="margin: 10px 0">
      <div class="title">
        <span
          @click="back"
          style="cursor: pointer; color: #4587ff; margin-right: 20px"
          ><i class="el-icon-arrow-left"></i>返回</span
        >
        任务详情
      </div>
    </div>
    <div class="operate_but" v-if="!isDat">
      <div
        class="zhiye"
        style="
          background: #fdf6ec;
          color: #f9ae3d;
          border-radius: 5px;
          font-size: 15px;
        "
        v-if="!dataInfo.qualified"
      >
        您暂不具备
        <span style="font-weight: bold; text-decoration: underline">
          {{ dataInfo.practiceName || '' }}
        </span>
        执业类型接单资格,
        <span
          @click="goApplyDetails(dataInfo.practiceName)"
          style="color: #55aaff; cursor: pointer; margin-left: 10px"
        >
          前往申请
        </span>
      </div>

      <div class="footer_box_big">
        <div
          class="prompt_warn"
          @click="isInfo = true"
          v-if="
            dataInfo.status == 1 &&
            dataInfo.qualified &&
            dataInfo.isElectronContract &&
            $store.state.user_info.id !== dataInfo.taskFromUserId
          "
        >
          受理此类任务需要签订<span
            style="color: #6a93ff"
            @click.stop="downFileUrl(dataInfo.contractTemplateExampleUrl)"
            >《{{ dataInfo.contractTemplateName }}》</span
          >
          <span style="color: #326afb; margin-left: 10px">点击填写信息</span>
        </div>
      </div>
    </div>
    <div class="order_info" style="gap: 10px" v-if="dataInfo.terminationReason">
      <div class="text" style="color: red">订单已终止</div>

      <div class="info_item">
        <div class="left">终止原因：</div>
        <div class="right">
          {{ dataInfo.terminationReason || '' }}
        </div>
      </div>
    </div>
    <div class="order_info">
      <div class="text">任务信息</div>

      <div class="info_item">
        <div class="left">执业类型：</div>
        <div class="right">
          {{ dataInfo.practiceName || '' }}
        </div>
      </div>

      <div class="info_item">
        <div class="left">执业地点：</div>
        <div class="right">
          {{ dataInfo.practiceAddres || '' }}
        </div>
      </div>

      <div class="info_item">
        <div class="left">任务名称：</div>
        <div class="right">
          {{ dataInfo.taskName || '' }}
        </div>
      </div>

      <div class="info_item">
        <div class="left">任务要求：</div>
        <div class="right">
          {{ dataInfo.taskRequire || '' }}
        </div>
      </div>

      <div class="info_item">
        <div class="left">相关资料：</div>
        <div class="right">
          <div class="item_sel" v-for="(el, i) in dataInfo.taskFiles" :key="i">
            <div
              class=""
              style=""
              @click="el.filePath ? downFile(el.filePath, el.fileName) : null"
            >
              {{ el.fileName || '' }}
            </div>
          </div>
        </div>
      </div>

      <div class="info_item">
        <div class="left">时限：</div>
        <div class="right">
          {{ dataInfo.taskHour || ''
          }}{{
            dataInfo.taskHourType == 0
              ? '个小时'
              : dataInfo.taskHourType == 1
              ? '天'
              : dataInfo.taskHourType == 2
              ? '个月'
              : dataInfo.taskHourType == 3
              ? '年'
              : ''
          }}
        </div>
      </div>

      <div class="info_item">
        <div class="left">价格：</div>
        <div class="right" style="font-family: 600; color: red">
          ￥{{ dataInfo.taskPrice || '' }}
        </div>
        <span style="font-size: 14px" @click="marginPop = true"
          >质保金<span style="color: #326afb">5%</span></span
        >
      </div>

      <div class="info_item" v-if="isDat">
        <div class="left">联系方式：</div>
        <div class="right">
          {{ dataInfo.contactInfo || '' }}
        </div>
      </div>

      <block v-if="dataInfo.taskType == 2">
        <div class="info_item">
          <div class="left">任务规格：</div>
          <div class="right">
            {{ dataInfo.project.projectName || '' }}
          </div>
        </div>

        <div class="info_item">
          <div class="left">任务流程：</div>
          <div class="right">
            <div v-for="(item, index) in dataInfo.specsList" :key="index">
              <span style="margin-right: 10px">{{ item.specsName || '' }}</span>
              <span style="margin-right: 10px">{{
                item.deliverables || ''
              }}</span>
              <span style="color: red">￥{{ item.price || '' }}</span>
            </div>
          </div>
        </div>
      </block>

      <div class="info_item" v-if="isDat">
        <div class="left">备注说明：</div>
        <div class="right">
          {{ dataInfo.remark || '' }}
        </div>
      </div>

      <!-- <div class="info_item" v-if="isDat && dataInfo.contractUrl">
				<div class="left">合同下载：</div>
				<div class="right" style="color: #55aaff;" @click="downFile(dataInfo.contractUrl)">
					点击下载
				</div>
			</div> -->
    </div>
    <div
      class=""
      style="margin-top: 30px"
      v-if="
        dataInfo.status === 9 &&
        $store.state.user_info.id !== dataInfo.taskFromUserId
      "
    >
      <div
        class="prompt_warn"
        style="margin-bottom: 15px"
        v-if="dataInfo.isElectronContract"
        @click="openContract"
      >
        发布此类任务需要签订《{{ dataInfo.practiceName }}》
        <span style="color: #6a93ff; margin-left: 10px">点击填写信息</span>
      </div>
      <div
        class="click_but clickText"
        style="margin-bottom: 10px"
        @click="receivingOrders()"
      >
        受理
        <div v-if="complete" style="margin-top: 3px; margin-left: 5px">
          <u-loading-icon
            mode="circle"
            size="16"
            color="#fff"
            inactive-color="#afafaf"
          ></u-loading-icon>
        </div>
      </div>
      <div class="click_but clickText" @click="show_pop1 = true">拒绝</div>
    </div>
    <div
      class="click_but"
      style="margin-top: 15px"
      v-if="dataInfo.contractUrl"
      @click="downFileUrl(dataInfo.contractUrl)"
    >
      查看合同
    </div>

    <div
      class="order_info"
      v-if="
        dataInfo.twqReminderAndTaskFeedBack &&
        dataInfo.twqReminderAndTaskFeedBack.length > 0
      "
    >
      <div class="text">反馈和催单</div>
      <div v-for="(el, i) in dataInfo.twqReminderAndTaskFeedBack" :key="i">
        <div class="feedback_box">
          <div class="time_box">
            <div
              class="drop"
              :style="{
                background:
                  el.taskAction == 3
                    ? '#f9ae3d'
                    : el.type == 1
                    ? '#00c853'
                    : el.type == 2
                    ? '#ea3e10'
                    : '#3c9cff',
              }"
            ></div>
            {{ el.createTime }}
          </div>
          <div class="title_box" v-if="el.taskAction !== 8">
            {{
              el.taskAction == 3
                ? `${
                    el.reminderUserId == $store.state.user_info.id
                      ? '您'
                      : '对方'
                  }发起了一次催单操作`
                : el.type == 1
                ? `验收简述：${el.content}`
                : el.type == 2
                ? `驳回说明：${el.content}`
                : `反馈内容：${el.content}`
            }}
          </div>
          <div class="title_box" v-else>
            <div class="" style="margin-bottom: 10px">
              评论内容：{{ el.reminderContent }}
            </div>
            <el-rate :value="el.star" disabled />
          </div>
          <div
            class="info_item"
            style="gap: 0px"
            v-if="el.taskAction !== 3 && el.files"
          >
            <div class="left" style="width: auto">
              {{ el.type == 1 ? '验收资料：' : '相关资料：' }}
            </div>
            <div class="right">
              <div class="item_sel" v-for="(val, ind) in el.files" :key="ind">
                <div
                  class=""
                  style=""
                  @click="
                    val.filePath ? downFile(val.filePath, val.fileName) : null
                  "
                >
                  {{ val.fileName }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom_btn" v-if="dataInfo.status == 7 && isExamine">
      <!-- <div class="" @click="showPop(2)">拒绝验收</div> -->
      <div class="" @click="showPop(1)">验收通过</div>
    </div>

    <!-- 保证金规则 -->
    <div class="popup" v-if="marginPop">
      <div class="margin_box">
        <img
          :src="fileUrl + 'group1/M00/12/39/L2rchmR4HOmAY9pAAACylwPvKjQ493.png'"
          mode=""
        />
        <span class="h1">质量保证金规则</span>
        <span class="cont_box"
          >为提升保障服务质量，客户支付总额的5%，作为质量保证金。根据用户评级扣减质量保证金。规则如下：</span
        >
        <div class="guizhe_hezhi">
          <div
            class="juti_guizhe"
            v-for="(it, i) in [1, 2, 3, 4, 5, 6]"
            :key="i"
          >
            <div class="dian"></div>
            {{ i }}星
            <div class="" style="margin-left: 10px">
              <el-rate :value="i" active-color="#f6b529" readonly size="19px" />
            </div>
            <div
              v-if="i !== 5"
              class=""
              style="color: #999999; margin-left: 20px"
            >
              扣减
              <span style="color: #326afb; margin-left: 5px">{{ 5 - i }}%</span>
            </div>
            <div v-else class="" style="color: #326afb; margin-left: 20px">
              不扣减
            </div>
          </div>
        </div>
        <div class="anl_box clickText" @click="marginPop = false">
          <img
            :src="
              fileUrl + 'group1/M00/12/1F/L2pUHWR4OXKAEjCJAAADHjGyMvY590.png'
            "
            mode=""
          />
          我已知悉
        </div>
      </div>
    </div>
    <div class="showDialog" v-show="show_pop">
      <div class="message_box" style="padding: 0">
        <div v-if="type == 1">
          <div class="title">
            <img :src="imgUrl + 'editedBooks_dialogTip.png'" mode="" />
            <span>验证完成确认</span>
          </div>
          <div class="subtitle">验收完成后，款项将支付给任务接单人。</div>
          <div class="rate_box">
            <span>评级</span>
            <el-rate v-model="stars" />
          </div>
          <div class="text_area_box">
            <textarea
              v-model="content"
              style="width: 100%; height: 100%; border: none; resize: none"
              placeholder="请输入评论"
              :maxlength="251"
            ></textarea>
          </div>
        </div>
        <div v-if="type == 2">
          <div class="title">
            <img :src="imgUrl + 'userPortfolio_dialogTip.png'" mode="" />
            <span>拒绝验收反馈</span>
          </div>
          <div class="subtitle">验收拒绝后，将此任务驳回给任务接单人。</div>
          <!-- <div class="rate_box">
						<span>评级</span>
						<u-rate v-model="stars" activeColor="#f6b529" size='38rpx' />
					</div> -->
          <div class="text_area_box">
            <textarea
              v-model="content1"
              style="width: 100%; height: 100%; border: none; resize: none"
              placeholder="驳回原因"
              :maxlength="251"
            ></textarea>
          </div>
        </div>
      </div>
      <div class="option">
        <div class="confirm" @click="clickConfirm">确认</div>
        <div class="cancel" @click="show_pop = false">取消</div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  receivingOrders,
  checkAccept,
  examine,
  entrustTaskEnd,
  taskConfirmAccepted,
  queryTwqCaseCause,
  queryTwqMandate,
  queryBTaskUserEnterInfo,
} from 'api/professionServer'
// import cascader from '@/components/cascader/cascader.vue'
export default {
  components: {
    // cascader,
  },
  props: ['dataInfo', 'isDat', 'isExamine'],
  data() {
    return {
      fileUrl: 'https://fafs.antiplagiarize.com/', // 图片url
      imgUrl:
        'https://payment-writemall-com.oss-cn-shenzhen.aliyuncs.com/miniapps/wqzk/', // 图片url
      str: '',
      marginPop: false,
      userinfo: JSON.parse(localStorage.getItem('userinfo')),
      show_pop: false,
      stars: 0,
      content: '',
      content1: '', //驳回说明
      type: 0,
      isInfo: false, // 信息弹窗
      isSignature: false, // 签名组件显示
      partyB: {
        // 乙方合同信息
        name: '',
        idCardNumber: '',
        address: '',
        shippingAddress: '',
        contacts: '',
        telephone: '',
        weChat: '',
        email: '',
        signature: '',
        serviceItems: '',
      },
      show_pop1: false, //拒绝弹框
      terminationReason: '', //拒绝接单原因
      isCascader: false, // 是否显示层级组件
      reasonList: [],
      cascaderXZ: {
        // 选中的案由
        name: '',
      },
      radioVal: 'LAWYER_AUTHORIZATION_GENERAL', // 授权选中
      mandateList: [], // 授权的数组
      complete: false,
    }
  },
  async created() {
    this.queryTwqMandate()
    let res = await queryTwqCaseCause({
      parentId: 0,
    })
    if (res.code !== 200) return
    this.reasonList = res.data
  },
  onShow() {
    this.complete = false
  },
  watch: {
    dataInfo(newD) {
      console.log(this.$parent.isExamine)
      this.queryBTaskUserEnterInfo()
    },
  },
  methods: {
    back() {
      this.$emit('back')
    },
    // 验证实名认证
    openContract() {
      let userInfo = JSON.parse(localStorage.getItem('userinfo'))
      if (userInfo.authenticationStatus !== 1 || !userInfo.hasIdcardNumberImg) {
        this.isPractice = false
        this.$refs.cDialog.displayFun({
          title: '提示',
          message: `${
            userInfo.authenticationStatus !== 1
              ? '选择该类型需要先实名认证'
              : userInfo.authenticationStatus == 1 &&
                !userInfo.hasIdcardNumberImg
              ? '已实名认证,请补充身份证正反面'
              : ''
          }`,
          confirmTxt: `${
            userInfo.authenticationStatus !== 1
              ? '去实名'
              : userInfo.authenticationStatus == 1 &&
                !userInfo.hasIdcardNumberImg
              ? '去补充'
              : ''
          }`,
          confirm: () => {
            if (userInfo.authenticationStatus !== 1) {
              //   uni.navigateTo({
              //     url: '/pages_three_level/realNameVerification/realNameVerification',
              //   })
            } else if (
              userInfo.authenticationStatus == 1 &&
              !userInfo.hasIdcardNumberImg
            ) {
              //   uni.navigateTo({
              //     url: '/pages_three_level/realNameVerification/realNameVerification?isAddImg=1',
              //   })
            }
          },
        })
        return
      }
      this.isInfo = true
    },
    async clickConfirm1() {
      if (!this.terminationReason) {
        this.$message.error('请输入拒绝接单原因')

        return
      }
      let opt = {
        taskId: this.dataInfo.id,
        terminationReason: this.terminationReason,
      }
      let res = await entrustTaskEnd(JSON.stringify(opt))
      if (res.code !== 200) return
      this.$message.success('拒绝接单成功')
    },

    showPop(type) {
      this.type = type
      this.show_pop = true
    },
    clickConfirm() {
      console.log(this.type)
      if (this.type == 1) {
        this.checkAccept()
        this.back()
      } else {
        this.examine()
      }
    },
    // 验收(任务发起人)
    async checkAccept() {
      if (!this.content) {
        this.$message.error('请输入评论')

        return
      }
      let data = {
        taskId: this.dataInfo.id,
        content: this.content,
        star: this.stars,
      }
      let res = await checkAccept(data)
      if (res.code !== 200) return
      this.show_pop = false
      this.$message.success('验证成功')

      this.$parent.goTaskDetails(this.$parent.id)
    },
    //拒绝验收
    async examine() {
      if (!this.content1) {
        this.$message.error('请填写驳回原因')

        return
      }
      let data = {
        content: this.content1,
        taskId: this.dataInfo.id,
        type: 2,
      }
      let res = await examine(data)
      if (res.code !== 200) return
      this.show_pop = false
      this.$message.success('驳回成功')

      this.$parent.goTaskDetails(this.$parent.id)
    },
    // 去 申请资格
    goApplyDetails() {
      this.$bus.$emit('goApplyDetails', 'Practice')
    },
    downFile(path, name) {
      window.location.href = path
    },
    receivingOrders() {
      let opt = {
        taskId: this.dataInfo.id,
      }
      if (this.dataInfo.isElectronContract) {
        let is = false
        Object.keys(this.partyB).forEach((el) => {
          if (!this.partyB[el]) {
            is = true
          }
        })
        if (is) {
          this.$message.error(
            `请将${this.dataInfo.practiceName}合同信息填写完整`
          )

          return
        }

        if (!this.cascaderXZ.name) {
          this.$message.error(`请选择案由`)

          return
        }

        opt.partyB = {
          ...this.partyB,
          cause: this.cascaderXZ.name,
          mandate: this.radioVal,
        }
      }
      let res
      this.complete = true
      if (this.dataInfo.status === 9) {
        this.$refs.cDialog.displayFun({
          title: '提示',
          message: '是否受理该任务',
          confirm: async () => {
            res = await taskConfirmAccepted(opt)
            this.complete = false
            if (res.code === 418) {
              this.$refs.cDialog.displayFun({
                title: '提示',
                message: res.data,
              })
              return
            }
            if (res.code !== 200) {
              return
            }
            this.$parent.goTaskDetails(this.$parent.id)
            // uni.navigateTo({
            //   url: '/pages_secondary/taskSystem/taskSystem?orderType=' + 1,
            // })
          },
        })
      } else {
        this.$refs.cDialog.displayFun({
          title: '提示',
          message: '是否接单',
          confirm: async () => {
            res = await receivingOrders(JSON.stringify(opt))
            this.complete = false
            if (res.code === 418) {
              this.$refs.cDialog.displayFun({
                title: '提示',
                message: res.data,
              })
              return
            }
            if (res.code !== 200) {
              return
            }
            this.$parent.goTaskDetails(this.$parent.id)
            this.subScribeMsg()
          },
        })
      }
    },
    selectCard() {},
    // downFileUrl(path) {
    //   let type
    //   if (path.includes('.doc')) {
    //     type = '.doc'
    //   }
    //   if (path.includes('.docx')) {
    //     type = '.docx'
    //   }
    //   // #ifdef MP-WEIXIN
    //   let filePath = `${wx.env.USER_DATA_PATH}/${'委托代理合同'}${type}`
    //   wx.downloadFile({
    //     url: path, // 自己换个其他的地址（"https://www.xxxxx.com/file/用户协议.pdf"）
    //     filePath: filePath,
    //     success: function (res) {
    //       if (res.statusCode != 200) {
    //         return false
    //       }
    //       var Path = res.filePath //返回的文件临时地址，用于后面打开本地预览所用
    //       wx.openDocument({
    //         filePath: Path,
    //         fileType: 'docx',
    //         showMenu: true,
    //         success: function (res) {},
    //       })
    //     },
    //     fail: function (err) {
    //       console.log(err)
    //     },
    //   })
    //   // #endif

    //   // #ifdef APP-PLUS
    //   uni.downloadFile({
    //     url: path,
    //     success: (res) => {
    //       uni.saveFile({
    //         tempFilePath: res.tempFilePath,
    //         success: (red) => {
    //           uni.openDocument({
    //             filePath: red.savedFilePath,
    //             showMenu: true,
    //             success: () => {},
    //             fail: () => {},
    //           })
    //         },
    //         fail: (red) => {
    //           console.log('shshshshs', red)
    //         },
    //       })
    //     },
    //     fail: () => {},
    //   })
    //   // #endif
    // },
    // 组件change事件
    async changeCascader(e) {
      if (e.value.hasNext) {
        let res = await queryTwqCaseCause({
          parentId: e.value.id,
        })
        if (res.code !== 200) return
        this.$refs.cascader.changeItem(res.data)
      } else {
        this.cascaderXZ = e.value
        this.isCascader = false
      }
    },
    // 授权查询
    async queryTwqMandate() {
      let res = await queryTwqMandate()
      if (res.code !== 200) return
      this.mandateList = res.data
    },
    // 获取合同详情回显
    async queryBTaskUserEnterInfo() {
      let res = await queryBTaskUserEnterInfo({
        typeId: this.dataInfo.practiceId,
      })
      if (res.code !== 200) return
      this.partyB.name = res.data.name
      this.partyB.idCardNumber = res.data.idCardNumber
      this.partyB.address = res.data.address
      this.partyB.shippingAddress = res.data.shippingAddress
      this.partyB.contacts = res.data.contacts
      this.partyB.telephone = res.data.telephone
      this.partyB.weChat = res.data.weChat
      this.partyB.email = res.data.email
      this.partyB.signature = res.data.signature
      this.partyB.serviceItems = res.data.serviceItems
    },
    // 获取消息通知
    // subScribeMsg() {
    //   uni.getSetting({
    //     withSubscriptions: true,
    //     success(res) {
    //       console.log(res)
    //       if (!res.subscriptionsSetting.mainSwitch) {
    //         uni.openSetting({
    //           //打开设置页
    //           success(res) {
    //             console.log('打开设置页', res.authSetting)
    //           },
    //         })
    //       } else {
    //         uni.requestSubscribeMessage({
    //           tmplIds: ['whf9_8Qtnoxv-4qtUzwrdIWp_ojynKmKBc1QrHK7720'],
    //           success(res) {
    //             uni.navigateTo({
    //               url: '/pages_secondary/taskSystem/taskSystem?orderType=' + 1,
    //             })
    //           },
    //           fail(errMessage) {
    //             console.log('订阅消息 失败 ', errMessage)
    //             uni.navigateTo({
    //               url: '/pages_secondary/taskSystem/taskSystem?orderType=' + 1,
    //             })
    //           },
    //           complete() {},
    //         })
    //       }
    //     },
    //   })
    // },
  },
}
</script>

<style lang="scss" scoped>
.det_box {
  padding-bottom: calc(env(safe-area-inset-bottom) + 5px);
}

.operate_but {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;

  .zhiye {
    width: 100%;
    height: 50px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    font-size: 16px;
  }

  .apply_but {
    border: 1px solid #326afb;
    background-color: #fff;
    color: #326afb;
  }

  .footer_box_big {
    position: fixed;
    bottom: calc(env(safe-area-inset-bottom) + 5px);
  }
}

.order_info {
  margin-top: 10px;
  padding: 15px 10px;
  border-radius: 8px;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  gap: 20px;
  box-sizing: border-box;

  .text {
    font-size: 15px;
  }

  .info_item {
    display: flex;
    // align-items: center;
    gap: 22px;
    font-size: 14px;

    .left {
      width: 120px;
      color: #999999;
    }

    .right {
      flex: 1;

      .item_sel {
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;

        > div:first-child {
          font-size: 15px;
          color: #326afb;
        }
      }
    }
  }
}

.feedback_box {
  .time_box {
    font-size: 15px;
    color: #999;
    display: flex;
    align-items: center;

    .drop {
      width: 15px;
      height: 15px;
      border-radius: 50%;
      background: #ccc;
      margin-right: 10px;
    }
  }

  .title_box {
    font-size: 15px;
    color: #333;
    padding-left: 25px;
    box-sizing: border-box;
    margin-top: 10px;
  }

  .info_item {
    padding-left: 25px;
    margin-top: 5px;
    box-sizing: border-box;
  }
}

.click_but {
  // width: 395px;
  height: 50px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-size: 16px;
  background: linear-gradient(-90deg, #326afb, #e1252d);
  font-weight: 600;
  color: #fff;
}

.prompt_warn {
  color: #f9ae3d;
  background-color: #fdf6ec;
  padding: 10px 13px;
  width: 395px;
  box-sizing: border-box;
  border-radius: 5px;
  font-size: 13px;
  margin-bottom: 10px;
}

.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.39);

  .margin_box {
    width: 379px;
    height: 435px;
    padding-bottom: 20px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;

    > img {
      width: 100%;
      height: 100%;
      position: absolute;
      z-index: -1;
    }

    .h1 {
      font-size: 16px;
      font-weight: bold;
      color: #326afb;
      margin-top: 33px;
    }

    .cont_box {
      width: 227px;
      font-size: 11px;
      color: #333333;
      line-height: 22px;
      margin-top: 19px;
    }

    .guizhe_hezhi {
      width: 300px;
      height: 410px;
      background: #ffffff;
      box-shadow: 0px 3px 9px 1px rgba(88, 133, 215, 0.19);
      border-radius: 10px;
      margin-top: 19px;

      .juti_guizhe {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        font-size: 12px;
        margin-top: 13px;

        .dian {
          width: 5px;
          height: 5px;
          background: #cadfff;
          border-radius: 50%;
          margin-right: 15px;
        }
      }
    }

    .anl_box {
      width: 298px;
      height: 60px;
      background: linear-gradient(-90deg, #326afb, #80a3ff);
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      font-weight: 600;
      margin-top: 20px;

      > img {
        width: 15px;
        height: 15px;
        margin-right: 10px;
      }
    }
  }
}

.bottom_btn {
  width: calc(100% - 30px);
  display: flex;
  justify-content: space-around;
  // position: fixed;
  bottom: 0;
  // padding-bottom: calc(env(safe-area-inset-bottom) + 5px);
  padding-top: 10px;
  background: #fff;
  border-top: 1px solid #f8f8f8;

  > div:first-child {
    width: 125px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    background: #f6f6f6;
    color: #666;
  }

  > div:last-child {
    width: 125px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border-radius: 20px;
    background: #326afb;
    color: #fff;
  }
}

.showDialog {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
  width: 500px;
  padding: 15px;
  padding-bottom: 0;
  border-radius: 10px;
  .message_box {
    width: 100%;
    box-sizing: border-box;

    .title {
      display: flex;
      align-items: center;
      font-size: 17px;
      font-weight: bold;
      color: #333333;
      margin-bottom: 17px;

      > img {
        width: 20px;
        height: 20px;
        margin-right: 10px;
      }
    }

    .price_text_box {
      width: 100%;
      font-size: 14px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 17px;
    }

    .subtitle {
      font-size: 14px;
      color: #999999;
      margin-bottom: 17px;
    }

    .rate_box {
      display: flex;
      align-items: center;
      margin-bottom: 17px;

      > text {
        font-size: 15px;
        font-weight: bold;
        color: #333333;
        margin-right: 15px;
      }
    }

    .liyou {
      font-size: 15px;
      font-weight: 600;
      color: #333;
      margin-bottom: 15px;
    }

    .text_area_box {
      width: 100%;
      // height: 50px;
      padding: 15px;
      box-sizing: border-box;
      font-size: 15px;
      background: #f6f8fc;
      border-radius: 10px;
      height: 140px;
    }
  }
  .option {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    .confirm {
      font-size: 14px;
      color: #fff;
      background: #326afb;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 70px;
      border-radius: 5px;
    }
    .cancel {
      font-size: 14px;
      color: #fff;
      background: #999;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 70px;
      border-radius: 5px;
    }
  }
}

.infoClass {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;
  color: #333;
  overflow: auto;

  .infoTitle {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 10px;
  }

  .info_item {
    width: 100%;
    margin-top: 5px;
    padding: 13px 0px;
    box-sizing: border-box;
    border-bottom: 1px solid #dadbde;
    display: flex;
    align-items: center;
  }

  .left_info {
    font-size: 15px;
    min-width: 220px;

    > text {
      margin-right: 5px;
      font-weight: 600;
    }
  }

  .right_info {
    font-size: 15px;
  }
}

.but_box {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;

  > div {
    width: 48%;
    height: 40px;
    background-color: #326afb;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 25px;
  }

  .qux {
    background-color: #ececec;
    color: #333;
  }
}

.qmImg {
  width: 150px;
  transform: rotate(-90deg);
}

.contract_btn {
  width: 110px;
  height: 30px;
  padding: 0 16px;
  text-align: center;
  margin-left: 13px;
  line-height: 30px;
  border-radius: 15px;
  color: #333;
  border: 1px solid #f3f4f5;
  font-size: 13px;
}

.mandateClass {
  width: 100%;
  margin-top: 5px;
  padding: 13px 0px;
  box-sizing: border-box;
  border-bottom: 1px solid #dadbde;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 30px;
  .tit_box {
    font-size: 16px;
    font-weight: bold;
    color: #000000;

    display: flex;
    align-items: center;
    justify-content: space-between;
    .tip {
      font-size: 12px;
      font-weight: normal;
      color: #333;
      > text {
        color: #326afb;
      }
    }
  }
  .title {
    position: relative;
    font-size: 16px;
    width: 100%;
    font-family: Microsoft YaHei;
    font-weight: 600;
    color: #333333;
    .el-button {
      position: absolute;
      top: -10px;
      right: 0;
    }
  }
  .more {
    font-size: 12px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
    cursor: pointer;
  }
}
</style>
